import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CityPage from "./pages/CityPage";
import StatePage from "./pages/StatePage";
import StatesDirectory from "./pages/StatesDirectory";
import CoverageTypePage from "./pages/CoverageTypePage";
import FindYourCity from "./pages/FindYourCity";
import { BlogList, BlogPost } from "./pages/Blog";
import AdminDashboard from "./pages/AdminDashboard";
import { PrivacyPolicy, TermsOfService, Disclaimer, Accessibility } from "./pages/LegalPages";

// 301 redirect for old insurance-type city pages → new city page
function OldInsuranceCityRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/quotes/${slug}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* CURRENT PAGES — these are indexed, don't touch */}
        <Route path="/" element={<HomePage />} />
        <Route path="/quotes/:slug" element={<CityPage />} />
        <Route path="/states" element={<StatesDirectory />} />
        <Route path="/states/:stateSlug" element={<StatePage />} />
        <Route path="/coverage/:slug" element={<CoverageTypePage />} />
        <Route path="/find-your-city" element={<FindYourCity />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/accessibility" element={<Accessibility />} />

        {/* 301 REDIRECTS — old insurance-type landing pages */}
        <Route path="/auto-insurance" element={<Navigate to="/coverage/liability" replace />} />
        <Route path="/home-insurance" element={<Navigate to="/" replace />} />
        <Route path="/life-insurance" element={<Navigate to="/" replace />} />
        <Route path="/health-insurance" element={<Navigate to="/" replace />} />
        <Route path="/business-insurance" element={<Navigate to="/" replace />} />
        <Route path="/commercial-insurance" element={<Navigate to="/" replace />} />

        {/* 301 REDIRECTS — old insurance-type + city combo pages */}
        <Route path="/auto-insurance/:slug" element={<OldInsuranceCityRedirect />} />
        <Route path="/home-insurance/:slug" element={<OldInsuranceCityRedirect />} />
        <Route path="/life-insurance/:slug" element={<OldInsuranceCityRedirect />} />
        <Route path="/health-insurance/:slug" element={<OldInsuranceCityRedirect />} />
        <Route path="/business-insurance/:slug" element={<OldInsuranceCityRedirect />} />
        <Route path="/commercial-insurance/:slug" element={<OldInsuranceCityRedirect />} />

        {/* CATCH-ALL — anything else goes to homepage */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
